export default {
  fontSize: '20px',
  outlineColor: '#4D90FE'
}
